module.exports = __webpack_public_path__ + "static/media/antano-choclo-maiz-y-queso-140g-800x800.2c056f48.webp";